<svg
  class={$$props.class}
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M12 2C9.51472 2 7.5 4.01472 7.5 6.5C7.5 8.98528 9.51472 11 12 11C14.4853 11 16.5 8.98528 16.5 6.5C16.5 4.01472 14.4853 2 12 2Z"
    fill="currentColor"
  />
  <path
    d="M3.50192 20.4563C3.91318 15.7691 7.21844 12 12 12C14.0819 12 15.8839 12.7145 17.289 13.9082C16.8095 14.2735 16.5 14.8506 16.5 15.5V16.5H15.5C14.3954 16.5 13.5 17.3954 13.5 18.5C13.5 19.6046 14.3954 20.5 15.5 20.5H16.5V21H4C3.85979 21 3.72603 20.9411 3.63132 20.8377C3.53661 20.7344 3.48966 20.596 3.50192 20.4563Z"
    fill="currentColor"
  />
  <path
    d="M19 15.5C19 15.2239 18.7761 15 18.5 15C18.2239 15 18 15.2239 18 15.5V18H15.5C15.2239 18 15 18.2239 15 18.5C15 18.7761 15.2239 19 15.5 19H18V21.5C18 21.7761 18.2239 22 18.5 22C18.7761 22 19 21.7761 19 21.5V19H21.5C21.7761 19 22 18.7761 22 18.5C22 18.2239 21.7761 18 21.5 18H19V15.5Z"
    fill="currentColor"
  />
</svg>
